import { render, staticRenderFns } from "./Parlor.vue?vue&type=template&id=71c1aa71&scoped=true&"
import script from "./Parlor.vue?vue&type=script&lang=js&"
export * from "./Parlor.vue?vue&type=script&lang=js&"
import style0 from "./Parlor.vue?vue&type=style&index=0&id=71c1aa71&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71c1aa71",
  null
  
)

export default component.exports